<template>
	<div class="genealogy">
		<div class="group-content" ref="genealogy-book">

		</div>
		<div class="load-more" v-if="genealogyNext.length>0">
			<van-loading type="spinner" color="#1989fa" size="16px" @click="toLoadMore" v-if="timesLoadData<=0">点击继续载入...</van-loading>
			<van-loading type="spinner" color="#1989fa" size="16px" @click="toLoadMore" v-else>数据载入中...</van-loading>
		</div>
	</div>
</template>

<script>
import {Card, SwipeCell } from "vant";
import {num2chinese } from "@/utils/common.js";
import {lunarUtil} from "@/utils/lunar.js";

export default {
	name: "genealogy",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell
	},
	props:{
		pedigree_id:String,
		pedigree_num:String,
		scsx:Object,
		book_name:String,
		show_book:Boolean
	},
	data() {
		return {
			title: '',
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			
			genealogyTbodyElm:null,
			genealogyTrElm:null,
			titleElm:null,

			sourceData:null,

			lunarObj:null,

			genealogyNext:[],
			genealogyUpObj:null,

			timesLoadData:10,
			ROW_FONT_LENGTH:25
		};
	},
	created() {
		this.title = this.book_name;
		let that = this;
		this.$nextTick(() => {
			that.lunarObj = new lunarUtil();
			that.init();
		});
	},
	computed: {
		zongxiArrs:function(){
			let zxArr = ['世祖'];
			for(var i=2;i<101;i++){
				zxArr.push(num2chinese(i)+'世')
			}
			return zxArr;
		},
		orderArrs:function(){
			let xdArr = ['未知','长子','次子'];
			for(var i=3;i<101;i++){
				xdArr.push(num2chinese(i)+'子')
			}
			return xdArr;
		}
	},
	methods: {
		init(){
			let tbElm = document.createElement("table");
			tbElm.style.borderSpacing = "0px";
			let tbodyElm = document.createElement("tbody");
			let trElm = document.createElement("tr");
			let tdElm = null;

			tdElm = document.createElement("td");
			tdElm.style.padding = "0 15px";
			//tdElm.style.writingMode = "vertical-rl";
			//tdElm.style.textAlign = "left";
			tdElm.style.verticalAlign = "top";
			//tdElm.style.fontSize = "18px";
			//tdElm.style.fontWeight = "bold";
			//tdElm.style.width = "20px";
			tdElm.style.wordBreak = "break-all";
			tdElm.innerHTML = '<div class="txt txt-title">'+this.title+'</div>';
			this.titleElm = tdElm;

			trElm.appendChild(tdElm);
			tbodyElm.appendChild(trElm);
			tbElm.appendChild(tbodyElm);
			this.$refs['genealogy-book'].appendChild(tbElm);
			this.genealogyTrElm = trElm;
			this.genealogyTbodyElm = tbodyElm;

			this.getSourceData();

		},
		getFatherName(t, curId, psrId, father, up, canUp){
			//console.log([t, curId, psrId, father,up]);
			let n='';
			if(t==-1){
				n = father;
			}
			if(t>=1){
				n = document.querySelector('#name_r_'+psrId)?document.querySelector('#name_r_'+psrId).innerHTML:(document.querySelector('#name_'+psrId)?document.querySelector('#name_'+psrId).innerHTML:'');
			}
			if(t==0){
				n = (up||!psrId)?((this.sourceData&&this.sourceData.rchilds.indexOf('#'+father+'#')>-1)?this.sourceData.father:''):(document.querySelector('#name_'+psrId)?document.querySelector('#name_'+psrId).innerHTML:'');
				if(up && document.querySelector('#fname_'+psrId)){
					document.querySelector('#fname_'+psrId).innerHTML = father;
				}
				if(n=='' && this.genealogyUpObj && !canUp){
					n = this.genealogyUpObj.father;
				}
			}
			return n;
		},
		getRelName(t, orders){//父、祖、曾、高、天、烈、太、远、鼻。书中说：因人怀胎，鼻先受形，故鼻祖为始祖。
			let name = [];
			if(t>=1){
				name.push("双承");
				switch(t){
					case 1:
						name[0] = '双承子';
						break;
					case 2:
						name[0] = '双承孙';
						break;
					case 3:
						name.push('曾孙');
						break;
					case 4:
						name.push('玄孙');
						break;
					case 5:
						name.push('来孙');
						break;
					case 6:
						name.push('晜孙');
						break;
					case 7:
						name.push('仍孙');
						break;
					case 8:
						name.push('云孙');
						break;
					case 9:
						name.push('耳孙');
						break;
					default:
						name.push(num2chinese(t)+"代孙");
				}
			}
			if(t<1){
				name.push(orders>0?(orders==1)?"長子":(orders==2?'次子':(num2chinese(orders)+"子")):'');
			}
			return name;
		},
		initElm(t,r, psrId, up){
			var h = '';
			h += '<table style="writing-mode:horizontal-tb;border-spacing:0px;height:100%;width: max-content;">';
			h += '	<tr class="head">';
			h += '		<td>';
			h += '			<div class="txt txt-father" '+(t!=-1?('id="fname_'+r.id+'"'):'')+' style="">';
			h +=				this.getFatherName(t, r.id, psrId, r.father||r.name, up, r.ups);
			h += '			</div>';
			let relNames = this.getRelName(t, r.orders);
			for(var i=0,il=relNames.length; i<il; i++){
				h += '			<div class="txt txt-order" style="right:'+((i+1)*20+(i==0?2:0))+'px">';
				h +=				relNames[i];
				h += '			</div>';
			}
			h += '		</td>';
			h += '	</tr>';
			h += '	<tr class="body">';
			h += '		<td style="">';
			h += '		<div class="txt-name" style=""><span '+(t>=1?('adp_id="'+r.adp_id+'" rel="'+r.rel+'"'):"")+''+(t!=-1?('id="name_'+r.id+'"'):'')+' style="">'+r.name+'</span>'+(r.zihao?r.zihao:"")+'</div>';
			//if(t != 1){
				h += r.jishi?('<div class="txt txt-jishi" style="">'+("第"+num2chinese(r.jishi)+"世")+'</div>'):"";
			//}
			h += '		<div class="txt txt-birth" style="">';
			if(t>=1){ 
				h += "志在外详";
			}
			if(t==-1){
				h += r.birth_note;
			}
			h += '		</div>';
			if(t==-1){
				let conts = r.content.split(/\n|\r\n/);
				for(var i=0,il=conts.length; i<il; i++){
					if(conts[i]){
						h += '	<div class="txt">'+conts[i]+'</div>';
					}
				};
				if(r.childs){
					let childs = r.childs.split(",");
					h += '	<div class="txt txt-child"><span style="font-weight:bold;">子'+num2chinese(childs.length)+'</span>';
					h += '&nbsp;';
					for(var i=0,il=childs.length; i<il; i++){
						var clds = childs[i].split("#");
						h += clds[0];
						if(clds.length > 1){
							h += '<span class="small" style="font-size:10px;color:#999;margin-top:3px;">'+clds[1]+'</span>';
						}
						h += '&nbsp;';
					};
					h += '</div>';
				}
			}
			if(t != -1){
				let cont = null, pcont=null, cemetery=null, rr = null;
				if(t==0){ 
					cont = this.lunarObj.date2lunar(r.birthdate, r.birthday, r.hours?this.scsx[r.hours].sc:'', r.calendar, r.leep_month);
					h += '<div class="txt">';
					if(r.pastinfo){
						cemetery = r.pastinfo.cemetery;
						pcont = this.lunarObj.date2lunar(r.pastinfo.pastdate, r.pastinfo.pastday, r.pastinfo.hours, r.pastinfo.calendar, r.pastinfo.leep_month);
						if(cont == "" && pcont == ""){
							h += "生卒失考";
						}else if(cont != "" && pcont != ""){
							h += "生於"+cont;
							h += '</div><div class="txt">';
							h += "卒於"+pcont;
						}else{
							h += (cont==""?"生辰未详":"生於"+cont)+"&nbsp;";
							h += (pcont==""?"卒失考":"卒於"+pcont);
						}
					}else{
						h += (cont==""?"生辰未详":"生於"+cont)+"&nbsp;";
					}
					h += '</div>';
					
					if(r.remark){
						let rmks = r.remark.split(/\n|\r\n/);
						for(var i=0,il=rmks.length; i<il; i++){
							h += '	<div class="txt">'+rmks[i]+'</div>';
						};
					}
					if(cemetery){
						h += '<div class="txt">';
						h += '墓塟'+cemetery;
						h += '</div>';
						
					}
					if(r.metas && r.metas.length>0){
						for(var i=0,il=r.metas.length; i<il; i++){
							rr = r.metas[i];
							h += '<div class="txt">';
							h += '娶'+(rr.surname?rr.surname:' ')+"氏"+(rr.name?rr.name:'')+"&nbsp;";
							cont = this.lunarObj.date2lunar(rr.birthdate, rr.birthday, rr.hours?this.scsx[rr.hours].sc:'', rr.calendar, rr.leep_month);
							cemetery = "";
							if(rr.pastinfo){
								cemetery = rr.pastinfo.cemetery;
								pcont = this.lunarObj.date2lunar(r.pastinfo.pastdate, r.pastinfo.pastday, r.pastinfo.hours, r.pastinfo.calendar, r.pastinfo.leep_month);
								if(cont == "" && pcont == ""){
									h += "生卒失考";
									if(cemetery){
										h += '&nbsp;墓塟'+cemetery;
									}
								}else if(cont != "" && pcont != ""){
									h += "生於"+cont;
									h += '</div>';
									h += '<div class="txt">';
									h += "卒於"+pcont;
									if(cemetery){
										h += '</div>';
										h += '<div class="txt">';
										h += '墓塟'+cemetery;
									}
								}else{
									h += (cont==""?"生辰未详":"生於"+cont)+"&nbsp;";
									h += (pcont==""?"卒失考":"卒於"+pcont);
									if(cemetery){
										h += '</div>';
										h += '<div class="txt">';
										h += '墓塟'+cemetery;
									}
								}
							}else{
								h += (cont==""?"生辰未详":"生於"+cont)+"&nbsp;";
							}
							h += '</div>';
						};
					}

					if(r.edus && r.edus.length>0){
						for(var i=0,il=r.edus.length; i<il; i++){
							rr = r.edus[i];
							h += '<div class="txt">';
							h += this.lunarObj.year2Ch(rr.date_edu, rr.date_start, rr.date_end);
							h += '就读'+rr.school+"&nbsp;"+rr.professional;
							if(rr.education){
								h += '获'+rr.education+'学历';
							}
							h += '</div>';
						};
					}
					
					if(r.vitaes && r.vitaes.length>0){
						for(var i=0,il=r.vitaes.length; i<il; i++){
							rr = r.vitaes[i];
							h += '<div class="txt">';
							h += this.lunarObj.year2Ch(rr.date_vitae, rr.date_start, rr.date_end);
							h += rr.content;
							h += '</div>';
						};
					}
					
					if(r.houses && r.houses.length>0){
						for(var i=0,il=r.houses.length; i<il; i++){
							rr = r.houses[i];
							h += '<div class="txt">';
							var hv = this.lunarObj.year2Ch(rr.date_house, rr.date_build, rr.date_finished);
							if(rr.note){
								hv += rr.note;
							}else if(rr.builds){
								hv += '与'+rr.builds+(rr.types==3?"合建":"合购");
							}else{
								hv += (rr.types==1?"建":"购");
							}
							hv += ' '+rr.name+'一座';
							if(rr.direction){
								hv += rr.direction;
							}
							if(rr.address){
								hv += ' 位于'+rr.address;
							}
							if(hv.length > this.ROW_FONT_LENGTH){
								h += hv.substr(0,this.ROW_FONT_LENGTH);
								var subf = 1;
								while(subf*this.ROW_FONT_LENGTH < hv.length){
									h += '</div>';
									h += '<div class="txt">';
									h += hv.substr(this.ROW_FONT_LENGTH*subf,this.ROW_FONT_LENGTH);
									subf++;
								}
							}else{
								h += hv;
							}
							h += '</div>';
							
						};
					}
				}

				var clds = [];
				var aclds = [];
				if(r.childs){

					for(var i=0,il=r.childs.length; i<il; i++){
						rr = r.childs[i];

						clds.push(rr.name+(rr.types==1?'<span class="small" style="font-size:10px;color:#999;margin-top:3px;">入赘</span>':(rr.types==-1?'<span class="small" style="font-size:10px;color:#999;margin-top:3px;">抱养</span>':''))+(rr.adpots>0?'<span class="small" style="font-size:10px;color:#999;margin-top:3px;">双承男</span>':''));

						if(!up){
							this.genealogyNext.push({father:r.name, psrId:rr.id, sex:rr.sex, adpot:0});
						}

					}
				}

				if(r.relChilds){
					for(var i=0,il=r.relChilds.length; i<il; i++){
						rr = r.relChilds[i];
						aclds.push(rr.name+("<span class=\"small\" style=\"font-size:10px;color:#999;margin-top:3px;\">"+(rr.adpot<=2?"":this.lunarObj.num2Zh(rr.adpot)+"分之一")));
						if(!up){
							this.genealogyNext.push({father:r.name, psrId:r.id, sex:rr.sex, adpot:1,adp_id:rr.adp_id, rel:rr.rel+1,ind:i});//psrId:parseInt(rr.id.split('_')[1])
						}
					}
				}

				if(clds.length > 0){
					h += '<div class="txt txt-child"><span style="font-weight:bold;">';
					h += '子'+(clds.length>1?this.lunarObj.num2Zh(clds.length):"");
					h += '</span>&nbsp;'+clds.join('&nbsp;');
					h += '</div>';
				}

				if(aclds.length > 0){
					h += '<div class="txt txt-child"><span style="font-weight:bold;">';
					h += '双承子'+(aclds.length>1?this.lunarObj.num2Zh(aclds.length):"");
					h += '</span>&nbsp;'+aclds.join('&nbsp;');
					h += '</div>';
				}
			}
			
			h += '		</td>';
			h += '	</tr>';
			
			h += '</table>';
			return h;
		},
		filterSourceData(r){
			this.sourceData = r;
			let rchilds = [];
			if(r.childs){
				let childs = r.childs.split(",");
				let clds = null;
				for(var i=0,il=childs.length; i<il; i++){
					clds = childs[i].split("#");
					rchilds.push(clds[0]);
				};
			}
			this.sourceData.rchilds = '#'+rchilds.join('#')+'#';
		},
		getSourceData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.pedigree_id,
				p_num:this.pedigree_num,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/genealogySource" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 200){
					let datas = response.data.datas;
					if(datas){
						try{
						that.filterSourceData(datas[0]);
						}catch(e){}
						for(var i=0,il=datas.length; i<il; i++){
							let tdElm = document.createElement("td");
							//tdElm.style.writingMode = "vertical-rl";
							//tdElm.style.textAlign = "left";
							tdElm.style.verticalAlign = 'top';
							tdElm.innerHTML = that.initElm(-1,datas[i],-1,0);
							that.genealogyTrElm.insertBefore(tdElm, that.titleElm);
						}
					}
					
					setTimeout(() => {
						that.getGeaenlogyPersonal(null,null,0);
					},1000);
					return false;
				}
				if(response.data.msg){
					that.$toast.fail(response.data.msg);
				}
			})
			.catch(error => {});
		},
		getGeaenlogyPersonal(psrId,sex,qryup){
			var params = {
				u_id: this.u_id,
				token: this.token,
				p_id: this.pedigree_id,
				p_num: this.pedigree_num,
				psr_id: psrId,
				sex: sex,
				qryup: qryup||0,
				pdgonly:1,
				book:1
			};
			var url = this.Conf.serverUrl + "clans/pedigreeUser?num="+Math.random();
			let that = this;
			this.$axios.post(url, this.$qs.stringify(params))
			.then(response => {
				if (response.data.code == 200) {
					let list = response.data.data;
					let isQryUp = parseInt(response.data.params.qryup);
					let qryPsrId = response.data.params.psr_id;
					let tdElm = null;
					let insertObj = isQryUp?that.genealogyTrElm.querySelector('#geaenlogy_'+qryPsrId).nextSibling:that.genealogyTrElm.children[0];
					for(var i=0,il=list.length; i<il; i++){
						tdElm = document.createElement("td");
						//tdElm.style.writingMode = "vertical-rl";
						//tdElm.style.textAlign = "left";
						tdElm.style.verticalAlign = 'top';
						tdElm.setAttribute('id','geaenlogy_'+list[i].id);
						tdElm.innerHTML = that.initElm(0,list[i], qryPsrId, isQryUp);
						that.genealogyTrElm.insertBefore(tdElm, insertObj);
					}
					for(var i=0,il=list.length; i<il; i++){
						let pms = list[i];
						if(pms.ups){
							that.genealogyNext.push({father:pms.name, psrId:pms.id, sex:pms.sex, up:1});
							//that.getGeaenlogyPersonal(pms.id,pms.sex,1);
						}
					}
					that.timesLoadData--;
					that.loadNextGeaenlogy();
				}else if(response.data.msg){
					that.$toast.fail(response.data.msg);
				}
			})
			.catch(error => {});
		},
		loadAdpotPersonal(id,rind){
			let tbElm = document.querySelector('#name_r_'+id);
			var params = {
				u_id: this.u_id,
				token: this.token,
				psr_id: id,
				adp_id: tbElm?tbElm.getAttribute('adp_id'):0,
				rel: tbElm?tbElm.getAttribute('rel'):0,
				rind:rind
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/genealogyAdpotPersonal?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if (response.data.code == 200) {
					let list = response.data.datas;
					let psr_id = response.data.psr_id
					let rel = response.data.rel
					let tdElm = null;
					let pms = null;
					for(var i=0,il=list.length; i<il; i++){
						pms = list[i];
						tdElm = document.createElement("td");
						//tdElm.style.writingMode = "vertical-rl";
						//tdElm.style.textAlign = "left";
						tdElm.style.verticalAlign = 'top';
						tdElm.setAttribute('id','geaenlogy_'+pms.id);
						tdElm.innerHTML = that.initElm(rel,list[i],list[i].adp_id,0);
						that.genealogyTrElm.insertBefore(tdElm, that.genealogyTrElm.children[0]);			
						that.genealogyNext.push({father:list[i].name, psrId:list[i].id.split('_')[1], sex:list[i].sex, adpot:1,adp_id:list[i].adp_id, rel:list[i].rel+1,ind:i});//psrId:parseInt(rr.id.split('_')[1])
					}
					that.timesLoadData--;
					that.loadNextGeaenlogy();
				}
			})
			.catch(error => {});
		},
		loadNextGeaenlogy(){
			if(this.timesLoadData<=0) return false;
			if(this.$parent.$parent.showGenealogyBookPopup){
				this.genealogyUpObj = this.genealogyNext.shift();
				if(this.genealogyUpObj){
					setTimeout(() => {
						if(this.genealogyUpObj.adpot){
							this.loadAdpotPersonal(this.genealogyUpObj.psrId,this.genealogyUpObj.ind)
						}else{
							this.getGeaenlogyPersonal(this.genealogyUpObj.psrId,this.genealogyUpObj.sex,this.genealogyUpObj.up||0);
						}
					},1000);
				}
			}
		},
		toLoadMore(){
			if(!(this.u_id && this.token)){
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "登录后可以查看更多",
					showCancelButton:true,
					confirmButtonText:'马上登录',
					cancelButtonText:'再看看'
				})
				.then(() => {
					this.$router.push({ path: "/Login" });
					return false;
				})
				.catch(error => {
					return false;
				});
				return false;
			}
			this.timesLoadData = 10;
			this.loadNextGeaenlogy();
		}
	},
	watch:{
		show_book(n,o){
			if(n){
				this.loadNextGeaenlogy();
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/GenealogyBook.vue